// ProductTabVariant.js
// Chooses which ProductTab implementation to render based on product config styles.
// If configData.style.ProductTab is undefined or not recognized, fall back to the default ProductTab.

import React from 'react';
import ProductTab from './ProductTab';
import DeliverPrint_ProductTab from './DeliverPrint_ProductTab';

const normalize = (val) => (typeof val === 'string' ? val.trim().toLowerCase() : '');

const ProductTabVariant = (props) => {
  const styleId = normalize(
    props?.configData?.style?.ProductTab || props?.product?.style?.ProductTab || ''
  );

  switch (styleId) {
    case 'deliverprint':
      return <DeliverPrint_ProductTab {...props} />;
    // Add future variants here
    default:
      return <ProductTab {...props} />;
  }
};

export default ProductTabVariant;
